"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSession = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
/**
 * Get information about the current users of the widget.
 *
 * Notes: Since the datasheet can be share out, the id, name, avatar, ect. of the user information in the case of
 * not logged in is undefined.
 *
 * @returns
 *
 * ### Example
 * ```js
 * import { useSession } from '@apitable/widget-sdk';
 *
 * // Show the currently users name of the widget.
 * function Meta() {
 *   const session = useSession();
 *   return (<div>
 *     <p>{session.user.name}</p>
 *   </div>);
 * }
 * ```
 *
 */
function useSession() {
    const user = (0, react_redux_1.useSelector)(state => {
        var _a, _b, _c, _d, _e;
        return {
            id: (_a = state.user) === null || _a === void 0 ? void 0 : _a.userId,
            name: ((_b = state.user) === null || _b === void 0 ? void 0 : _b.memberName) || ((_c = state.user) === null || _c === void 0 ? void 0 : _c.nickName),
            email: (_d = state.user) === null || _d === void 0 ? void 0 : _d.email,
            avatar: (_e = state.user) === null || _e === void 0 ? void 0 : _e.avatar
        };
    }, react_redux_1.shallowEqual);
    return (0, react_1.useMemo)(() => {
        return {
            user
        };
    }, [user]);
}
exports.useSession = useSession;
